<template>
  <div class="express-track">
    <van-tabs v-model="active">
      <van-tab name='express' class="express-tab" title="物流跟踪">
        <div class="express-info">
          <!-- <van-row class="express-item-wrap">
            <van-col span="3">
              <div class="icon-wrap">收</div>
            </van-col>
            <van-col class="context" span="21">
              <div class="text">收货地址:{{express.address}}</div>
            </van-col>
          </van-row> -->
          <ExpressCard
            v-for="(express, index) in expressList"
            :key="index"
            :express="express"
          />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {
  Swipe,
  SwipeItem,
  Field,
  Row,
  Col,
  DropdownMenu,
  DropdownItem,
  Button,
  Tab,
  Tabs,
  Notify
} from 'vant'

import {
  ConvertNumber
} from '@utils/basicUtil'

import ExpressCard from '@components/ExpressCard'

import { invoiceRequest } from '@services'

export default {
  // props: ['loading'],
  data: () => ({
    active: 'express',
    express: {
      address: ''
    },
    expressList: [
    ]
  }),
  mounted () {
    this.getExpressInfo()
    this.configWechat()
  },
  methods: {
    convertNumber (data) {
      return ConvertNumber(data)
    },
    async getExpressInfo (id) {
      const {
        logisticsNo,
        mobile,
        shipperCode
      } = this.$route.query
      const data = await invoiceRequest.express.expressTrackList({
        logisticNo: logisticsNo,
        mobile,
        shipperCode
      })
      if (data.success) {
        this.expressList = data.result[0].traces.reverse()
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    configWechat () {
      const wx = window.wx
      // 分享到朋友圈
      wx.onMenuShareTimeline({
        title: '您有一张发票物流状态跟踪', // 分享标题
        desc: '点击查看', // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/logo.png', // 分享图标
        success: function (res) {
          // 用户确认分享后执行的回调函数
          console.log('分享到朋友圈成功返回的信息为:', res)
        },
        cancel: function (res) {
          // 用户取消分享后执行的回调函数
          console.log('取消分享到朋友圈返回的信息为:', res)
        }
      })
      // 分享给朋友
      wx.onMenuShareAppMessage({
        title: '您有一张发票物流状态跟踪', // 分享标题
        desc: '点击查看', // 分享描述
        link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/logo.png', // 分享图
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function (res) {
          // 用户确认分享后执行的回调函数
          console.log('分享给朋友成功返回的信息为:', res)
        },
        cancel: function (res) {
          // 用户取消分享后执行的回调函数
          console.log('取消分享给朋友返回的信息为:', res)
        }
      })
      // 分享到QQ
      wx.onMenuShareQQ({
        title: '您有一张发票物流状态跟踪', // 分享标题
        desc: '点击查看', // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/logo.png', // 分享图标
        success: function (res) {
          // 用户确认分享后执行的回调函数
          console.log('分享到QQ好友成功返回的信息为:', res)
        },
        cancel: function (res) {
          // 用户取消分享后执行的回调函数
          console.log('取消分享给QQ好友返回的信息为:', res)
        }
      })
      // 分享到QQ空间
      wx.onMenuShareQZone({
        title: '您有一张发票物流状态跟踪', // 分享标题
        desc: '点击查看', // 分享描述
        link: window.location.href, // 分享链接
        imgUrl: 'https://smarttax-basic.oss-cn-shanghai.aliyuncs.com/resource/logo.png', // 分享图标
        success: function (res) {
          // 用户确认分享后执行的回调函数
          console.log('分享到QQ空间成功返回的信息为:', res)
        },
        cancel: function (res) {
          // 用户取消分享后执行的回调函数
          console.log('取消分享到QQ空间返回的信息为:', res)
        }
      })
    }
  },
  components: {
    ExpressCard,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Field.name]: Field,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  }
}

</script>

<style lang="less" scoped src="./style.less"/>
